import { Button } from '@/common/ui/Form/Button'
import { Input } from '@/common/ui/Form/Input'
import { useCompetitionModal } from '../model'
import { Fieldset } from '@/common/ui/Form/Fieldset'

type CompetitionFormProps = {
    onBack?: () => void
    modalId?: string
}

export const CompetitionForm = ({ onBack }: CompetitionFormProps) => {
    const { form, handleSubmit, register, onSubmit, errors, isSubmitting, submitError } = useCompetitionModal()

    return (
        <form className='modal-form' onSubmit={handleSubmit(onSubmit)}>
            <h3 className='text-lg font-bold'>Укажите ссылку на товар конкурента</h3>

            <>
                <div className='modal-form-fields'>
                    <div className='modal-form-field'>
                        <Fieldset errorText={errors.url?.message} required>
                            <Input
                                className='w-full'
                                beforeIcon='link'
                                size='lg'
                                placeholder='Введите ссылку на товар'
                                type='text'
                                {...register('url', {
                                    required: 'Введите ссылку на товар',
                                    pattern: {
                                        value: /^https?:\/\/.+/,
                                        message: 'Введите корректную ссылку',
                                    },
                                })}
                            />
                        </Fieldset>
                    </div>
                </div>
                {submitError && (
                    <div className='alert alert-error'>
                        <span>Ошибка: {submitError.message}</span>
                    </div>
                )}

                <div className='flex items-center justify-end gap-2'>
                    <Button emphasis='secondary' variant='ghost' size='lg' onClick={onBack}>
                        Назад
                    </Button>
                    <Button
                        type='submit'
                        size='lg'
                        emphasis='accent'
                        disabled={isSubmitting || !form.formState.isValid}
                        loading={isSubmitting}
                    >
                        Добавить
                    </Button>
                </div>
            </>
        </form>
    )
}
